import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_023",
  "use": "icon-su_023-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_023\"><defs><style>#icon-su_023 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_023_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_023_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"18.71 6.71 17.29 5.29 12 10.59 6.71 5.29 5.29 6.71 10.59 12 5.29 17.29 6.71 18.71 12 13.41 17.29 18.71 18.71 17.29 13.41 12 18.71 6.71\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol